import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { useState } from 'react';

/**
 * Mostra a senha provisória devolvida pelo /resetPassword.
 *
 * É a única vez que ela aparece: o servidor guarda só o hash e não tem como
 * exibi-la de novo. Por isso o aviso é explícito e o botão de copiar existe —
 * senha reescrita à mão é senha digitada errada.
 */
export default function TemporaryPasswordModal({ isOpen, onClose, dados }) {

    const [copiado, setCopiado] = useState(false)

    const copiar = async () => {
        try {
            await navigator.clipboard.writeText(dados.temporaryPassword)
            setCopiado(true)
            setTimeout(() => setCopiado(false), 2500)
        } catch {
            // Sem permissão de área de transferência: a senha continua visível
            // na tela para ser copiada à mão.
            setCopiado(false)
        }
    }

    const fechar = () => {
        setCopiado(false)
        onClose()
    }

    if (!dados) return null

    return (
        <Dialog open={isOpen} onClose={fechar} className="relative z-[100]">

            <DialogBackdrop transition className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in" />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4">
                    <DialogPanel className="w-full max-w-[520px] rounded-md bg-white p-6 shadow-xl">

                        <h2 className="text-[1.2rem] font-semibold text-[#004B9B]">
                            Senha provisória gerada
                        </h2>

                        <p className="mt-2 text-sm text-gray-700">
                            Senha de <b>{dados.fullName || dados.username}</b> (<b>{dados.username}</b>) redefinida.
                            Entregue a senha abaixo à pessoa — ela será obrigada a trocá-la no próximo login.
                        </p>

                        <div className="mt-4 flex items-center gap-3 rounded-md border border-gray-300 bg-gray-50 p-3">
                            <code className="flex-1 select-all break-all font-mono text-[1.05rem] text-black">
                                {dados.temporaryPassword}
                            </code>
                            <button
                                type="button"
                                onClick={copiar}
                                className="btn btn-azul-prof shrink-0 px-3 py-1 text-sm"
                            >
                                {copiado ? 'Copiado!' : 'Copiar'}
                            </button>
                        </div>

                        <p className="mt-3 text-sm font-medium text-red-600">
                            Anote agora: esta senha não será exibida novamente.
                        </p>

                        <div className="mt-6 flex justify-end">
                            <button type="button" onClick={fechar} className="btn btn-azul-prof px-6">
                                Fechar
                            </button>
                        </div>

                    </DialogPanel>
                </div>
            </div>

        </Dialog>
    )
}
